import React from 'react';
import { Link } from 'react-router-dom';
import './ConceptOverview.css';

const ConceptOverview = () => {
  const concepts = [
    {
      id: 'what-is-miden',
      title: 'What is Miden?',
      description: 'A privacy-first blockchain that lets you prove actions without revealing details.',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      id: 'how-proofs-work',
      title: 'How proofs work',
      description: 'Your device runs code locally, creates a proof, and the chain verifies it instantly.',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z" stroke="currentColor" strokeWidth="2"/>
        </svg>
      )
    },
    {
      id: 'accounts-notes',
      title: 'Accounts & notes',
      description: 'Private accounts hold your assets. Notes move value between accounts invisibly.',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
          <path d="M8 8h8M8 12h8M8 16h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      )
    },
    {
      id: 'client-side-proving',
      title: 'Client-side proving',
      description: 'Everything runs on your device first. Only proofs go to the chain, keeping your data private.',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
          <line x1="8" y1="21" x2="16" y2="21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <line x1="12" y1="17" x2="12" y2="21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      )
    }
  ];

  return (
    <div className="concept-overview">
      <div className="concept-cards-strip">
        {concepts.map((concept) => (
          <Link
            key={concept.id}
            to={`/concept/${concept.id}`}
            className="concept-card"
          >
            <div className="concept-icon">{concept.icon}</div>
            <h3 className="concept-title">{concept.title}</h3>
            <p className="concept-description">{concept.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ConceptOverview;

